import { Form, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FormFooter from '../../../../../components/form-footer';
import IntakeInsuranceInvestigationPersonalHomeownersRentersAdditionalInformationFields from '../../../../../components/intake/insurance-investigation/personal/homeowners-renters/additional-information-fields';
import InsuranceInvestigationPersonalHomeownersRentersAdditionalInformationSchema from '../../../../../validation-schemas/insurance-investigation-personal-homeowners-renters-additional-information-schema';
import { selectActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation, updateActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation } from '../../../../../reducers/active-form-slice';
import FormHeaderButtons from '../../../form-header-buttons';
import { hasNonBlankValues } from '../../../../../utility/has-values';


const IntakeInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    /**
     * get current form values
     */
    const insuranceInvestigationPersonalHomeownersRentersAdditionalInformation = useSelector(selectActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation);
    const hasValues = hasNonBlankValues(insuranceInvestigationPersonalHomeownersRentersAdditionalInformation);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/insurance-investigation-personal-homeowners-renters/details");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        letterOfAcknowledgement: '',
        defendantProofOfInsuranceCard: '',
        defendantDriversLicense: '',
        trafficCollisionReport: ''
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? insuranceInvestigationPersonalHomeownersRentersAdditionalInformation : initialValues}
                validationSchema={InsuranceInvestigationPersonalHomeownersRentersAdditionalInformationSchema.fields.insuranceInvestigationPersonalHomeownersRentersAdditionalInformation}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, touched, isValid, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Additional Information</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeInsuranceInvestigationPersonalHomeownersRentersAdditionalInformationFields
                            errors={errors}
                            touched={touched}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`70`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeInsuranceInvestigationPersonalHomeownersRentersAdditionalInformation;